import"../defaults.js";const e=(e,t)=>({color:e.color||t.color||`#858585`,borderColor:e.borderColor||t.borderColor||`#ccc`});export{e as extractInputFieldStyles};
//# sourceMappingURL=extract-input-field-styles.js.map